import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useCustomerEndpoint } from '@aibees/shared/workspace';
import { BrowsePaymentCardRequest, BrowsePaymentCardResponse } from './types';

export function useBrowsePaymentCardApi() {
  const endpoint = useCustomerEndpoint('paymentMethod');

  return useBaseQuery<BrowsePaymentCardRequest, BrowsePaymentCardResponse>(
    [useBrowsePaymentCardApi.name],
    {
      url: endpoint,
    }
  );
}
